import 'css-chunksrc/client/scenes/projectExpenseCreation/form/elementAttachmentsUpload/dropZone/styles.scss';export default {};